import { render, staticRenderFns } from "./StaffManagement.vue?vue&type=template&id=4f884862"
import script from "@/scripts/adminManager/systemManager/staffManagement.js?vue&type=script&lang=js&external"
export * from "@/scripts/adminManager/systemManager/staffManagement.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports